import React from "react";
import { Routes, Route } from "react-router-dom";
import { ScrollToTop } from "../components";

// user manage
import UserList from "../pages/user-manage/UserList";
import UserCards from "../pages/user-manage/UserCards";
import UserProfile from "../pages/user-manage/UserProfile";
import UserEdit from "../pages/user-manage/UserEdit";

// delivery boys

// seller manage
// seller manage
import OrderList from '../pages/order-manage/OrderList';
// admin
import Profile from "../pages/admin/Profile";
import ProfileSettings from "../pages/admin/ProfileSettings";

// ecommerce
import AddProduct from "../pages/ecommerce/AddProduct";
import EditProduct from "../pages/ecommerce/EditProduct";

// auths pages
import AuthLogin from "../pages/auths/AuthLogin";

import NotFound from "../pages/error/NotFound";
import HomeEcommerce from "../pages/HomeEcommerce";
import AutenticationCheck from "../pages/AutenticationCheck";

import CategoriesList from "../pages/categories-manage/CategoriesList";
import ProductsList from "../pages/products-manage/ProductsList";
import CountriesList from "../pages/countries-manage/CountriesList";
import StatesList from "../pages/states-manage/StatesList";
import CitiesList from "../pages/cities-manage/CitiesList";

import PrivateRoute from './PrivateRoute';
import CouponsList from "../pages/coupons/CouponsList"
import CustomTickets from "../pages/TicketingSystem/CustomTickets"
import KanbanCustomPage from "../pages/kanban/KanbanCustom"
import ShipSettings from "../pages/Settings/ShipSettings"
import TaxSettings from "../pages/Settings/TaxSettings"
import CountryDetails from "../pages/Settings/CountryDetails"
import Home from "../pages/Home"
import DeliveryChargeList from "../pages/Settings/DeliveryChargeList";
import DChargeCountryDetails from "../pages/Settings/DChargeCountryDetails";
import DeliveryChargeListDummy from "../pages/Settings/DeliveryChargeListDummy";

function Router() {
  return (
    <ScrollToTop>
      <Routes>
        <Route path="auths">
          <Route path="auth-login" element={<AuthLogin />} />
        </Route>
        <Route path="/" element={<AuthLogin />} />
        <Route path="dashboard" element={<Home/>} />
        <Route
          path="*"
          element={
            <PrivateRoute>
              <AutenticationCheck />
            </PrivateRoute>
          }
        >
          <Route path="home-ecommerce" element={<HomeEcommerce />} />
          <Route path="user-manage">
            <Route path="user-list" element={<UserList />} />
            <Route path="user-cards" element={<UserCards />} />
            <Route path="user-profile/:id" element={<UserProfile />} />
            <Route path="user-edit/:id" element={<UserEdit />} />
          </Route>

          <Route path="order-manage">
            <Route path="order-list" element={<OrderList />} />
            <Route path="order-list/:restaurant_id" element={<OrderList />} />
          </Route>

          <Route path="categories-manage">
            <Route path="categories-list" element={<CategoriesList />} />
            <Route path="categories-list/:category_id" element={<CategoriesList />} />
          </Route>
          <Route path="coupons-manage">
            <Route path="coupons-list" element={<CouponsList/>} />
            <Route path="coupons-list/:coupon_id" element={<CouponsList />} />
          </Route>
          <Route path="products-manage">
            <Route path="products-list" element={<ProductsList />} />
            <Route path="products-list/:product_id" element={<ProductsList />} />
          </Route>
          <Route path="tickets-manage">
            <Route path="tickets-list" element={<CustomTickets />} />
            <Route path="tickets-list/:ticket_id" element={<CustomTickets />} />
          </Route>
          <Route path="whatsapp-list" element={<KanbanCustomPage />} />

          <Route path="countries-manage">
            <Route path="countries-list" element={<CountriesList />} />
            <Route path="countries-list/:country_id" element={<CountriesList />} />
          </Route>
          <Route path="settings-manage">
            {/* <Route path="shipping-list" element={<ShipSettings />} /> */}
            {/* <Route path="shipping-list/:shipping_id" element={<ShipSettings />} /> */}
            
            <Route path="delivery-list" element={<DeliveryChargeListDummy />} />
            {/* <Route path="delivery-list" element={<DeliveryChargeList />} /> */}
            {/* <Route path="delivery-list/:charge_id" element={<DeliveryChargeList />} /> */}

            <Route path="tax-list" element={<TaxSettings />} />
            <Route path="tax-list/:tax_id" element={<TaxSettings />} />
          </Route>
          <Route path="states-manage">
            <Route path="states-list" element={<StatesList />} />
            <Route path="states-list/:zone_id" element={<StatesList />} />
          </Route>
          <Route path="cities-manage">
            <Route path="cities-list" element={<CitiesList />} />
            <Route path="cities-list/:city_id" element={<CitiesList />} />
          </Route>

          <Route path="admin">
            <Route path="profile" element={<Profile />} />
            <Route path="profile-settings" element={<ProfileSettings />} />
          </Route>

          <Route path="ecommerce">
            <Route path="add-product" element={<AddProduct />} />
            <Route path="edit-product/:id" element={<EditProduct />} />
          </Route>
          <Route path="taxcountry/:country_id" element={<CountryDetails />} />

          {/* NEW ROUTE */}
          <Route path="deliverycountry/:country_id" element={<DChargeCountryDetails />} />
          {/* END NEW ROUTE */}

          <Route path="not-found" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />

        </Route>
      </Routes>
    </ScrollToTop>
  );
}

export default Router;
